<template>
    <ItemBase
        :id="id"
        class="item-card"
    >
        <TableList :lender="lender" />
    </ItemBase>
</template>

<script>
import ItemBase from './ItemBase.vue';
export default {
    components: { ItemBase },
    extends: ItemBase,
    props: {
        id: {
            type: String,
            required: true
        }
    }
}
</script>
